const hosteo =
  process.env.NODE_ENV === "production"
    ? ""
    : "https://gestion.osvestido.com.ar";

export default hosteo;
